/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCustomerBio} from '../api'

 export const useQueryGetCustomerBio = createReactQueryHook('getCustomerBio', getCustomerBio)
